import * as ng from 'angular';

export const IsEmpty: ng.FilterFactory = ($filter: ng.IFilterService) => {
    let bar;
    return (obj) => {
        for (bar in obj) {
            if (obj.hasOwnProperty(bar)) {
                return false;
            }
        }
        return true;
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/filters/is-empty.filter.ts